<template>
    <div class="hairworkpage" style="padding: 10px;height: 100%;font-size: 12px;">
        <div>
            <div style="display:inline-block;vertical-align: top;" @click.stop="openHairBasic">
                <van-uploader :file-list="[{url:staffinfo.icon}]"  max-count="1" image-fit="" preview-size="100px"	:preview-full-image="false" :deletable="false"/>
            </div>
            <div style="display:inline-block;width: 100px;height: 100px;vertical-align: top;margin-left: 10px;">
                <div>{{staffinfo.staffname}}</div>
                <div style="margin-top: 25px;">洗剪吹:{{staffinfo.washjc}}</div>
                <div style="margin-top: 25px;">老客:{{staffinfo.gl}}</div>
            </div>
            <div style="display:inline-block;width: 100px;height: 100px;vertical-align: top;">
                <div>{{staffinfo.posname}}</div>
                <div style="margin-top: 25px;">洗吹:{{staffinfo.washc}}</div>
                <div style="margin-top: 25px;"><el-button size="mini" type="primary" @click="openAddHairWork">发布作品</el-button></div>
            </div>
        </div>

        <div style="margin-top: 10px;" @click="openHairBasic">
            个人简介:{{staffinfo.introduce}}<span class="el-icon-arrow-right"></span>
        </div>
        <h6>作品</h6>
        <div style="margin-top:10px;height: calc(100% - 10rem);overflow: auto;">
            <van-list v-model="loading" :finished="isfinite" @load="load" finished-text="加载完成" style="height: 100%;margin-bottom: 20px;">
                <el-card class="box-card" size="mini" v-for="(item,index) in works" :key="index" style="margin-bottom: 10px;" shadow="never">
                    <div slot="header" class="clearfix">
                        <span>{{item.workname}}</span>
                        <span v-if="item.status==99" style="float: right;color:#409eff;">已审核</span>
                        <span type="danger" v-else style="float: right;color:#f56c6c">待审核</span>
                    </div>
                    <van-uploader :file-list="item.fileList" :max-count="item.billtype==2?1:3" />
                </el-card>
            </van-list>
        </div>
    </div>
</template>
<script>
    export default {
      data() {
        return {
          fileList: [],
          staffinfo: {},
          staffid: localStorage.getItem("querystaffid"),
          curpage: 0,
          isfinite: false,
          works: [],
          loading: false,
        }
      },
      created: function () {
        this.getStaffInfoById();
      },
      methods: {
        openHairBasic(){
          this.$router.push({
            path: "/hairbasic", query: {
              staffid: this.staffid,
            }
          });
        },
        load() {
          this.curpage++;
          this.getStaffWorksByStaffIdByPage();
        },
        getStaffWorksByStaffIdByPage() {
          this.loading = true;
          this.$post("hairwork/getStaffWorksByStaffIdByPage", {
            staffid: this.staffid,
            curpage: this.curpage,
            pagesize: 5
          }).then(res => {
            if (res.sucess) {
              this.loading = false;
              let obj = res.object;
              //this.works=[];
              if (obj != null && obj.length > 0) {
                for (let val of obj) {
                  let image = new Object();
                  if (val.work1) {
                    image.url = this.baseImageUrl + val.work1;
                    image.deletable = false;
                    this.fileList.push(image);
                  }
                  if (val.work2) {
                    image = new Object();
                    image.url = this.baseImageUrl + val.work2;
                    image.deletable = false;
                    this.fileList.push(image);
                  }
                  if (val.work3) {
                    image = new Object();
                    image.url = this.baseImageUrl + val.work3;
                    image.deletable = false;
                    this.fileList.push(image);
                  }
                  this.$set(val, "fileList", this.fileList);
                  this.fileList = [];
                  this.works.push(val);
                }
                console.log(this.works);
              } else {
                this.isfinite = true;
              }
            } else {
              this.$message({
                message: res.message,
                type: 'error'
              });
              this.isfinite = true;
            }
          });
        },
        openAddHairWork() {
          this.$router.push({
            path: "/addhairwork", query: {
              staffid: this.staffid,
            }
          });
        },
        getStaffInfoById() {
          this.$post("newcardapp/getStaffById", {
            staffid: this.staffid
          }).then(res => {
            if (res.sucess) {
              this.staffinfo = res.object;
              if (this.staffinfo != null) {
                if (this.staffinfo.icon) {
                  this.staffinfo.icon = this.baseImageUrl + this.staffinfo.icon;
                }
              }
            } else {
              this.$message({
                message: res.message,
                type: 'error'
              });
            }
          });
        }
      }
    }
</script>
<style style lang="scss" rel="stylesheet/scss">
    .hairworkpage .el-tag{
        height:0px;
        line-height:0px;
    }

    .hairworkpage .el-button--mini, .el-button--mini.is-round{
        padding:4px 10px;
    }

    .hairworkpage .el-card__body{
        padding: 10px;
    }

    .hairworkpage .el-card__header{
        padding:8px 10px;
    }
</style>



// WEBPACK FOOTER //
// src/page/hair/hairwork.vue